var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'sms-code': 'sms-code', disable: _vm.isDisable },style:(_vm.pos),on:{"click":_vm.getSmsCode}},[_vm._v(_vm._s(_vm.tip))])
}
var staticRenderFns = []

export { render, staticRenderFns }